const paymentsReqTimout = 60 * 1000;
const paymentsReqMode = 'cors';

export const PAYMENTS_COMMON_REQ_PARAMS = {
  mode: paymentsReqMode,
  timeout: paymentsReqTimout
};
